import React, { Fragment } from 'react';
import SectionHeader from '../../common/SectionHeader';
import Section from '../../common/Section';
import ResourceFilter from './ResourceFilter';
import SchedulerView from './SchedulerView';
import ScheduleService from '../../../services/ScheduleService';

class ProjectSchedule extends React.Component {

  constructor(props) {
    super(props);

    this.onFilterResources = this.onFilterResources.bind(this);

    this.unassigned = {
      id: -999, name: "Unassigned"
    };

    this.state = {
      filter: undefined,
      roles: [],
      totalCount: 0,
      resources: []
    };
  }

  componentDidMount() {

    const project = { ...this.props.project.attributes };

    const filter = {
      languages: project.languages,
      skillLevel: project.complexity.toString(),
      locations: []
    };

    ScheduleService
      .getTaskSectionById(project.projectType, this.props.sectionId)
      .then(response => {
        this.setState({
          filter: filter,
          roles: [...response.attributes.roles]
        }, this.loadResources);
      });
  }

  onFilterResources(criteria) {
    this.setState({ filter: Object.assign({}, criteria) }, this.loadResources);
  }

  loadResources() {

    const langIds = this.state.filter.languages.reduce((idArray, language) => {
      idArray.push(language.id.toString());
      return idArray;
    }, []);

    const { locations, skillLevel } = this.state.filter;
    const filterParameters = { locations, skillLevel, languages: langIds, roles: [...this.state.roles] };

    ScheduleService.getResources(filterParameters)
      .then(result => {
        const resources = result.items.reduce((list, resource) => {
          const { id, attributes } = resource;
          list.push({ id, ...attributes });
          return list;
        }, []);

        this.setState({
          resources: [this.unassigned, ...resources],
          totalCount: result.totalCount
        });
      });
  }

  render() {

    const pageTitle = `Schedule - Project: ${this.props.project.attributes.projectNumber}`;

    return (
      <Fragment>
        <SectionHeader title={pageTitle} />
        {this.state.filter &&
          <Fragment>
            <ResourceFilter
              onSearch={this.onFilterResources}
              onClear={this.onFilterResources}
              initialValues={this.state.filter} />
            <Section className="edit-page summary">
              <SchedulerView
                resources={this.state.resources}
                sectionId={this.props.sectionId}
                projectId={this.props.project.id} />
            </Section>
          </Fragment>}
      </Fragment>
    );
  }
}

export default ProjectSchedule;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSchedule/index.js